import React, { Component, Fragment } from 'react';
import InventoryHeader from './InventoryHeader';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import moment from 'moment';

@inject('InventoryStore')
@observer
class InventoryStockCountShift extends Component {
    render() {
        return (
            <Fragment>
                <InventoryHeader title="Daily Addons Check" backLink="" />
                <div className="inventory-menu">
                    <h2>{moment().format('dddd - DD/MM/YYYY')}</h2>
                    <div className="btn-wrapper mm mtxl">
                        <Link
                            to={{
                                pathname: `/inventory/stock-count/addons/initial`,
                                state: { itemType: 'Addons' },
                            }}
                        >
                            <button className="btn btn-primary width--300px">
                                Initial Daily Check
                            </button>
                        </Link>
                    </div>
                    <div className="btn-wrapper mm">
                        <Link
                            to={{
                                pathname: `/inventory/stock-count/addons/final`,
                                state: { itemType: 'Addons' },
                            }}
                        >
                            <button className="btn btn-primary width--300px">
                                Final Daily Check
                            </button>
                        </Link>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default InventoryStockCountShift;
